/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AccessEntry,
  AccessEntry$inboundSchema,
  AccessEntry$Outbound,
  AccessEntry$outboundSchema,
} from "./accessentry.js";

export type AccessListResponse = {
  object: "list";
  data: Array<AccessEntry>;
};

/** @internal */
export const AccessListResponse$inboundSchema: z.ZodType<
  AccessListResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(AccessEntry$inboundSchema),
});
/** @internal */
export type AccessListResponse$Outbound = {
  object: "list";
  data: Array<AccessEntry$Outbound>;
};

/** @internal */
export const AccessListResponse$outboundSchema: z.ZodType<
  AccessListResponse$Outbound,
  z.ZodTypeDef,
  AccessListResponse
> = z.object({
  object: z.literal("list"),
  data: z.array(AccessEntry$outboundSchema),
});

export function accessListResponseToJSON(
  accessListResponse: AccessListResponse,
): string {
  return JSON.stringify(
    AccessListResponse$outboundSchema.parse(accessListResponse),
  );
}
export function accessListResponseFromJSON(
  jsonString: string,
): SafeParseResult<AccessListResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AccessListResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AccessListResponse' from JSON`,
  );
}
